import React from 'react';
import ItemWithTooltip from './ItemWithTooltip';
import { ItemDotGrayComponent } from '../../ItemDotGray';

type Props = {
  item: any;
  isSimple: boolean;
  isExpanded: boolean;
};

const DotGrayItem: React.FC<Props> = ({ item, isSimple, isExpanded }) => (
  <ItemWithTooltip item={item}>
    <ItemDotGrayComponent
      item={item}
      isSimple={isSimple}
      isExpanded={isExpanded}
    />
  </ItemWithTooltip>
);

export default DotGrayItem;
